var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConsultoriaUltra(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 75,
    viewBox: "0 0 110 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.9831 37.4822L95.3386 26.4072L14.8764 0.111328L0.720215 19.1306V46.9619L18.6323 48.2655V66.5556L40.8471 69.3548V54.8565L44.7515 54.3982V69.836L78.2217 74.026L109.669 70.0281V40.1943L95.9831 37.4822ZM91.23 36.5402L77.9856 33.9157L48.469 39.8662L18.1142 36.6127V6.10531L90.8303 29.8701L91.23 36.5402ZM27.1126 44.1712L12.073 43.0862L16.1768 41.1252L33.1797 42.9481L27.1126 44.1712ZM5.41386 20.5912L13.4202 9.90917V37.2417L5.41386 41.0683V20.5912ZM36.153 50.6789V64.0349L23.3259 62.4168V49.7235L75.6548 39.1744L75.863 69.0004L49.4452 65.6936V49.1242L36.153 50.6789ZM98.537 66.7114L95.4218 67.1073V49.2934L98.537 49.7112V66.7114ZM90.728 67.7041L87.6128 68.1001V48.2465L90.728 48.6642V67.7041ZM104.975 65.8929L103.231 66.1146V45.6041L82.9189 42.8842V68.6968L80.557 68.9969L80.3489 39.1697L104.975 44.0476V65.8929Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5121 18.2345L29.4365 12.7278V28.7349L49.5121 32.0381V18.2345ZM44.8183 26.5104L34.1303 24.7512V18.8796L44.8183 21.8128V26.5104Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultoriaUltra);
export default __webpack_public_path__ + "static/media/consultoriaUltra.7ee828cd6dec5f2ec7669f2487554cfa.svg";
export { ForwardRef as ReactComponent };